import Header from '../components/Header';
import * as locCon from '../LocalConstants';
import CustomButton from '../elements/CustomButton';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import { goToThirdPartyLink } from '../community-hats-js-library/utils/generalFunctions';

export function ToolsMainPage() {
  const i18n = RefContextLanguage();

  // Trade

  // Current Page
  const setCurrentPage = RefSetCurrentPage();

  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={true} />

        {/* Available Tools*/}
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('availableTools')}</CustomText>

        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => goToThirdPartyLink(locCon.INTERNET_SPEED_TEST_LINK)}>
          {i18n.t('checkInternetConnection')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => goToThirdPartyLink(locCon.WIKI_LINK)}>
          {i18n.t('gotoWiki')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_PARTICIPANT_INTAKE_FORM)}>
          {i18n.t('participantIntakeForm')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_HOUSE_INTAKE_FORM)}>
          {i18n.t('houseIntakeForm')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_RECURENT_SURVEYS)}>
          {i18n.t('perceptualSurvey')}
        </CustomButton>
        <CustomButton
          type={locCon.PRIMARY_BUTTON}
          onClick={() => setCurrentPage(locCon.PAGE_WOMENS_MENTAL_AND_HEALTH_SURVEYS)}
        >
          {i18n.t('womensAndMentalHealthSurvey')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_TOOL_FITBIT_API_UPDATER)}>
          {i18n.t('updateFitbitAPI')}
        </CustomButton>
        <CustomButton
          type={locCon.PRIMARY_BUTTON}
          onClick={() => setCurrentPage(locCon.PAGE_TOOL_GOOGLE_HEALTH_API_UPDATER)}
        >
          {i18n.t('updateGoogleHealthAPI')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_TOOL_LOCATION_EXTRACTOR)}>
          {i18n.t('locationExtractor')}
        </CustomButton>
        <CustomButton
          type={locCon.PRIMARY_BUTTON}
          onClick={() => setCurrentPage(locCon.PAGE_TOOL_WEARABLE_SERIAL_CHECKER)}
        >
          {i18n.t('wearableSerialChecker')}
        </CustomButton>
        <CustomButton
          type={locCon.PRIMARY_BUTTON}
          onClick={() => setCurrentPage(locCon.PAGE_TOOL_GOVEE_ACTIVATION_CODES)}
        >
          {i18n.t('goveeActivationCodes')}
        </CustomButton>
        <CustomButton
          type={locCon.PRIMARY_BUTTON}
          onClick={() => setCurrentPage(locCon.PAGE_TOOL_CORRECT_PHONE_SERIAL)}
        >
          {i18n.t('correctPhoneSerial')}
        </CustomButton>

        <div className={'horizontalLine'} />
      </div>
    </div>
  );
}

export default ToolsMainPage;
